import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { ClientConfigService } from 'src/app/core/client/client-config.service';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
declare var google;

@Component({
  selector: 'app-user-cabang-add',
  templateUrl: './user-cabang-add.component.html',
  styleUrls: ['./user-cabang-add.component.scss'],
})
export class UserCabangAddComponent implements OnInit {

  load: boolean = false;
  saving: any = {};
  idData: any;

  detData: any = {};
  det: any;
  tampilData: boolean = false;
 
  cabang: any = '';
  grup: any = '';
  nama: any = '';
  namaAlias: any = '';
  namaAliasError = '';
  showNamaAlias = false;
  radius: any = '';
  jabatan: any = '';
  phone: any = '';
  email: any = '';
  username: any = '';
  password: any = '';

  usertype: any = '';

  toleransi: any = '';
  pulang: any = '';
  masuk: any = '';

  targetLeads: number | null = null;
  targetNominal: number | null = null;
  targetNominalDisplay: string = '';
  targetPencairan: number | null = null;
  targetPencairanDisplay: string = '';
  targetCollector: number | null = null;
  targetCollectorDisplay: string = '';

  disabledInput: boolean = false;
  mapsx: any = '';
  latitude: any = -6.175056284357598;
  longitude: any = 106.82715794388344;

  tampilAlamat: boolean = false;
  latlong: any = '';

  dataAlamat: any = {};
  dataAlamatDom: any = {};
  dataAlamatKirim: any = '';

  kelurahanktp: any = '';
  kelurahanId: any = '';
  alamatktp: any = '';

  dataAlamatJSON: any;
  title: any = '';
  desc: any = '';

  constructor(
    public api: ApiService,
    public util: UtilService,
    public navParams: NavParams,
    private clientConfig: ClientConfigService,
  ) {
    
   }

  ngOnInit() {
    this.showNamaAlias = this.clientConfig.isAnyClient('BAV', 'KOSPINUS');
    this.idData = this.navParams.data.id;
    console.log('idData',this.idData)
    if(this.idData){
      this.disabledInput = true;
      this.detailData()
      this.title = 'Ubah Data';
      this.desc = 'Isi kelengkapan data cabang yang akan diubah';
    }else{
      this.disabledInput = false;
      this.tampilData = true;
      this.tampilAlamat = true
      this.title = 'Tambah Data';
      this.desc = 'Isi kelengkapan data cabang yang akan ditambahkan';
    }
  }

  ionViewWillEnter(){
    // this.mapsx = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBiK5-chVyfuv43pco55C7bBvyugH3zWiU&q=' + this.latitude + ',' + this.longitude;
    // console.log('latitude', this.latitude, ' + longitude', this.longitude);
  }

  dateSelection(data: any) {
    // console.log('dateSelection',data)
    this.masuk = data;
  }

  dateSelectionout(data: any) {
    // console.log('dateSelection',data)
    this.pulang = data;
  }

  handleData(data: any) {
    // this.dataAlamatKirim = data;
    this.dataAlamat = JSON.parse(data);
    console.log('dataAlamat',this.dataAlamat)
    this.kelurahanktp = this.dataAlamat.kelurahanktp;
    this.alamatktp = this.dataAlamat.alamatktp;
    this.kelurahanId = this.dataAlamat.kelurahanIdktp;

  }

  async initMap() {
    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps");
    const myLatlng = { lat: this.latitude, lng: this.longitude };
    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 6,
      center: myLatlng,
      disableDefaultUI: true,
    });
    // Create the initial InfoWindow.
    let infoWindow = new google.maps.InfoWindow({
      content: "Click the map to get Lat/Lng!",
      position: myLatlng,
    });
  
    infoWindow.open(map);
    // Configure the click listener.
    map.addListener("click", (mapsMouseEvent) => {
      // Close the current InfoWindow.
      infoWindow.close();
      // Create a new InfoWindow.
      infoWindow = new google.maps.InfoWindow({
        position: mapsMouseEvent.latLng,
      });
      infoWindow.setContent(
        JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2),
      );
      infoWindow.open(map);
    });
  }
  
  toMaps(){
    var url = 'https://www.google.com/maps';
    console.log('url', url);
    // window.location.href = url;
    window.open(url, '_blank');
  }

  detailData(){
    this.api.get('backoffice/cabang/'+this.idData)
      .subscribe((data) => {
        this.detData = data;
        if (this.detData.error == 0) {
          this.nama = this.detData?.data?.name || '-';
          this.namaAlias = this.detData?.data?.inisial || this.detData?.data?.alias || '';
          this.radius = this.detData?.data?.radius_absensi || '-';
          this.masuk = this.detData?.data?.jam_kerja_in || '-';
          this.pulang = this.detData?.data?.jam_kerja_out || '-';
          this.toleransi = this.detData?.data?.tolerance_telat || '-';
          this.latlong = this.detData?.data?.latitude+', '+this.detData?.data?.longitude || '-';
          this.targetLeads = this.detData?.data?.target_leads ?? null;
          this.targetNominal = this.detData?.data?.target_nominal ?? null;
          this.targetNominalDisplay = this.targetNominal !== null ? this.util.formatIntegerForDisplay(this.targetNominal) : '';
          this.targetPencairan = this.detData?.data?.target_pencairan ?? null;
          this.targetPencairanDisplay = this.targetPencairan !== null ? this.util.formatIntegerForDisplay(this.targetPencairan) : '';
          this.targetCollector = this.detData?.data?.target_collection ?? null;
          this.targetCollectorDisplay =
            this.targetCollector !== null && this.targetCollector !== undefined
              ? String(this.targetCollector)
              : '';

          if(this.detData?.data?.subdistricts_id){
            this.dataAlamatJSON = JSON.stringify({
              "ktp_subdistricts_name" : this.detData?.data?.subdistricts_name || '-' +', '+this.detData?.data?.districts || '-'+', '+this.detData?.data?.city || '-'+', '+this.detData?.data?.province || '-',
              "ktp_address" : this.detData?.data?.address || '-',
              "ktp_subdistricts_id" : this.detData?.data?.subdistricts_id || '-',
            })
            this.alamatktp = this.detData?.data?.address || '-';
            this.kelurahanId = this.detData?.data?.subdistricts_id || '-';
          }
          this.alamatktp = this.detData?.data?.address || '-';

          setTimeout(() => {
            if(this.detData?.data?.subdistricts_id){
            this.tampilAlamat = true;
            }
            this.load = false;
            this.tampilData = true;

            }, 1000);
        } else {
          this.load = false;
          this.util.showToast(this.detData?.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  save(){
    if (!this.nama || !this.radius || !this.masuk || !this.pulang || !this.toleransi || !this.latlong || !this.kelurahanId || !this.alamatktp) {
      this.util.showToast('Semua field wajib diisi', 'danger', 'bottom');
      return;
    }

    if (this.showNamaAlias && !this.idData) {
      const alias = String(this.namaAlias || '').trim();

      if (!alias) {
        this.namaAliasError = 'Nama Alias Cabang wajib diisi (minimal 3, maksimal 5 karakter)';
        this.util.showToast(this.namaAliasError, 'danger', 'bottom');
        return;
      }

      if (!/^[A-Za-z0-9]+$/.test(alias)) {
        this.namaAliasError = 'Nama Alias Cabang hanya huruf dan angka';
        this.util.showToast(this.namaAliasError, 'danger', 'bottom');
        return;
      }

      if (alias.length < 3) {
        this.namaAliasError = 'Nama Alias Cabang minimal 3 karakter';
        this.util.showToast(this.namaAliasError, 'danger', 'bottom');
        return;
      }

      if (alias.length > 5) {
        this.namaAliasError = 'Nama Alias Cabang tidak boleh lebih dari 5 karakter';
        this.util.showToast(this.namaAliasError, 'danger', 'bottom');
        return;
      }

      this.namaAliasError = '';
    }

    if (this.targetLeads === null || this.targetNominal === null || this.targetPencairan === null || this.targetCollector === null) {
      this.util.showToast('Target bulanan wajib diisi', 'danger', 'bottom');
      return;
    }

    if (!this.util.isNumericOnlyList([this.radius, this.toleransi, this.targetLeads, this.targetNominal, this.targetPencairan])) {
      this.util.showToast('Field numerik harus angka saja tanpa huruf dan simbol', 'danger', 'bottom');
      return;
    }

    if (String(this.latlong).indexOf(',') === -1) {
      this.util.showToast('Format koordinat tidak valid. Gunakan format: latitude, longitude', 'danger', 'bottom');
      return;
    }

    this.load = true;
    var latLongArray = this.latlong.split(','); 
    this.latitude = latLongArray[0].trim();
    this.longitude = latLongArray[1].trim();

    let form: any = {
      name: this.nama,
      jam_kerja_in: this.masuk,
      jam_kerja_out:this.pulang,
      tolerance_telat: this.toleransi,
      subdistricts_id: this.kelurahanId,
      radius_absensi: this.radius,
      alamat_lengkap: this.alamatktp,
      longitude: this.longitude,
      latitude: this.latitude,
      target_leads: this.targetLeads,
      target_nominal: this.targetNominal,
      target_pencairan: this.targetPencairan,
      target_collection: this.targetCollector,
    };

    if (this.showNamaAlias && !this.idData) {
      form.inisial = String(this.namaAlias).trim();
    }
    console.log(form)
    if(this.idData){
      this.api.put('backoffice/cabang/'+this.idData, form)
      .subscribe((data) => {
        this.saving = data;
        if (this.saving.error == 0) {
          this.load = false;
          this.util.showToast(this.saving.message, 'success', 'bottom');
          this.api.dismissData('','confirm');

        } else {
          this.load = false;
          this.util.showToast(this.saving.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
    }else{
    this.api.post('backoffice/cabang', form)
      .subscribe((data) => {
        this.saving = data;
        if (this.saving.error == 0) {
          this.load = false;
          this.util.showToast(this.saving.message, 'success', 'bottom');
          this.api.dismissData('','confirm');

        } else {
          this.load = false;
          this.util.showToast(this.saving.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
    }
  }

  handleSelection(selectedValue: string, model: any) {
    if (model == 'cabang') {
      this.cabang = selectedValue;
    } else if (model == 'usertype') {
      this.usertype = selectedValue;
    } 
  }

  onNamaAliasInput(event: any) {
    const raw = (event ?? '').toString();
    const cleaned = raw.replace(/[^A-Za-z0-9]/g, '');

    if (raw !== cleaned && this.namaAlias === cleaned) {
      this.namaAlias = '';
      setTimeout(() => {
        this.namaAlias = cleaned;
        this.namaAliasError = '';
      });
      return;
    }

    this.namaAlias = cleaned;
    this.namaAliasError = '';
  }

  onTargetLeadsInput(event: any) {
    const raw = (event ?? '').toString().trim();
    if (raw === '') {
      this.targetLeads = null;
      return;
    }
    if (!this.util.isNumericOnly(raw)) {
      this.targetLeads = null;
      return;
    }
    this.targetLeads = Number(raw);
  }

  onTargetNominalInput(event: any) {
    const raw = (event ?? '').toString().trim();
    if (raw === '') {
      this.targetNominal = null;
      this.targetNominalDisplay = '';
      return;
    }

    if (!/^\d+$/.test(raw.replace(/\./g, ''))) {
      this.targetNominal = null;
      this.targetNominalDisplay = '';
      return;
    }

    const normalized = raw.replace(/\./g, '');
    this.targetNominal = Number(normalized);
    this.targetNominalDisplay = this.util.formatIntegerForDisplay(this.targetNominal);
  }

  onTargetPencairanInput(event: any) {
    const raw = (event ?? '').toString().trim();
    if (raw === '') {
      this.targetPencairan = null;
      this.targetPencairanDisplay = '';
      return;
    }

    if (!/^\d+$/.test(raw.replace(/\./g, ''))) {
      this.targetPencairan = null;
      this.targetPencairanDisplay = '';
      return;
    }

    const normalized = raw.replace(/\./g, '');
    this.targetPencairan = Number(normalized);
    this.targetPencairanDisplay = this.util.formatIntegerForDisplay(this.targetPencairan);
  }

  onTargetCollectorInput(event: any) {
    const raw = (event ?? '').toString();
    const normalized = this.util.normalizeDecimalInput(raw);

    if (raw !== normalized && this.targetCollectorDisplay === normalized) {
      this.targetCollectorDisplay = '';
      setTimeout(() => {
        this.targetCollectorDisplay = normalized;
      });
    } else {
      this.targetCollectorDisplay = normalized;
    }

    if (normalized === '' || normalized === '.') {
      this.targetCollector = null;
      return;
    }

    this.targetCollector = Number(normalized);
  }

  dismiss() {
    this.api.dismiss()
  }
}
